<div class="container_width">
  <div class="w-100% grid grid-nogutter">

    <div class="col-12 lg:col-3 lg:pr-4">
      <div class="sidebar-container">
        <h2 class="sidebar-title">Blogs</h2>

        <div class="flex flex-column gap-2">

          <a (click)="selectCategory(null)"
            class="filterLink_1 flex align-items-center justify-content-between cursor-pointer"
            [class.active]="selectedCategoryId === null">
            <span class="text-left text-base">All Categories</span>
          </a>

          <div *ngFor="let category of categories" class="category-item" (mouseenter)="onCategoryHover(category)"
            (mouseleave)="onCategoryLeave(category)" style="padding: 0px !important">

            <div class="category-parent">
              <a (click)="selectCategory(category.id)"
                class="filterLink flex align-items-center justify-content-between cursor-pointer"
                [class.active]="selectedCategoryId === category.id">

                <span class="text-left text-base">{{ category.name }}</span>

                <div class="flex align-items-center gap-2">
                  <span class="category-count">
                    ({{ getCategoryCount(category.id) }})
                  </span>

                  <i *ngIf="(category?.children?.length ?? 0) > 0"
                    (click)="toggleCategory(category); $event.stopPropagation()" class="pi chevron-icon"
                    [class.pi-chevron-right]="!category.isExpanded" [class.pi-chevron-down]="category.isExpanded">
                  </i>
                </div>
              </a>
            </div>

            <div *ngIf="category?.children?.length && category.isExpanded"
              class="category-children flex flex-column gap-1" style="margin: 0px !important; padding: 8px !important">

              <a *ngFor="let child of category?.children" (click)="selectCategory(child.id)"
                class="filterLink_child child-link flex align-items-center justify-content-between cursor-pointer"
                [class.active]="selectedCategoryId === child.id">

                <span class="text-left text-sm">{{ child.name }}</span>
                <span class="category-count">
                  ({{ getCategoryCount(child.id) }})
                </span>
              </a>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 lg:col-9">
      <div class="w-100% grid">

        <ng-container *ngIf="isLoading">
          <div *ngFor="let _ of skeletonItems" class="col-12 md:col-6 lg:col-4">
            <div class="w-full h-full flex flex-column bg-white border-round-lg border-1"
              [ngStyle]="{ 'border-color': '#D0D0DD' }">

              <div
                class="w-full flex align-items-center justify-content-center border-bottom-1 border-round-top-lg overflow-hidden"
                [ngStyle]="{
                  'background-color': '#F6F8FF',
                  'aspect-ratio': '4 / 3',
                  'border-color': '#D0D0DD'
                }">

                <p-skeleton width="100%" height="100%"></p-skeleton>
              </div>

              <div class="w-full flex flex-column align-items-start gap-3 p-3">
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>

                <div class="flex align-items-center gap-2">
                  <p-skeleton shape="circle" size="22px"></p-skeleton>
                  <p-skeleton width="10rem" height="1rem"></p-skeleton>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!isLoading">
          <div *ngFor="let blog of blogs" class="col-12 md:col-6 lg:col-4">

            <a [href]="blog.link" target="_blank" class="blog-card-link">

              <div class="w-full h-full grid grid-cols-12 bg-white border-round-lg border-1 blog-card"
                [ngStyle]="{ 'border-color': '#D0D0DD' }">

                <div
                  class="w-full flex align-items-center justify-content-center border-bottom-1 border-round-top-lg overflow-hidden"
                  [ngStyle]="{
                    'background-color': '#F6F8FF',
                    'aspect-ratio': '4 / 3',
                    'border-color': '#D0D0DD'
                  }">

                  <img [src]="getFeaturedImage(blog!)" [alt]="blog?.title?.rendered"
                    style="width: 100%; height: 100%; object-fit: cover;" (error)="onImageError($event)">
                </div>

                <div class="w-full flex flex-column align-items-start gap-3 p-3">

                  <b class="w-full text-left text-bluegray-900 hover:text-blue-900 text-md blog-title"
                    [innerHTML]="blog?.title?.rendered">
                  </b>

                  <div class="flex align-items-center gap-2" style="font-size: 14px;">
                    <img src="../../../../assets/icons/calendar_icon.svg" alt="" style="width: 16px;">

                   <div style="display: flex; align-items: center; gap: 0.5rem;">
                      <span class="text-color-secondary text-sm blog-meta">
                        {{ formatDate(blog.date) }}
                      </span>
                      <i class="pi pi-circle-fill" style="font-size: 0.3rem; line-height: 1;"></i>
                      <span class="font-md text-gray-600">{{ calculateReadingTime(blog) }} min read</span>
                    </div>
                  </div>

                </div>
              </div>
            </a>
          </div>

          <div *ngIf="!blogs || blogs.length === 0" class="col-12">
            <div class="no-results">
              <p class="text-center text-lg" [style.color]="'#818088'">
                No blogs found in this category.
              </p>
            </div>
          </div>

          <ng-container *ngIf="isLoadingMore">
            <div *ngFor="let _ of skeletonItems" class="col-12 md:col-6 lg:col-4">

              <div class="w-full h-full flex flex-column bg-white border-round-lg border-1"
                [ngStyle]="{ 'border-color': '#D0D0DD' }">

                <div
                  class="w-full flex align-items-center justify-content-center border-bottom-1 border-round-top-lg overflow-hidden"
                  [ngStyle]="{
                    'background-color': '#F6F8FF',
                    'aspect-ratio': '4 / 3',
                    'border-color': '#D0D0DD'
                  }">

                  <p-skeleton width="100%" height="100%"></p-skeleton>
                </div>

                <div class="w-full flex flex-column align-items-start gap-3 p-3">
                  <p-skeleton width="100%" height="1.5rem"></p-skeleton>

                  <div class="flex align-items-center gap-2">
                    <p-skeleton shape="circle" size="22px"></p-skeleton>
                    <p-skeleton width="10rem" height="1rem"></p-skeleton>
                  </div>
                </div>

              </div>
            </div>
          </ng-container>

        </ng-container>
      </div>
    </div>

  </div>
</div>